import {appRoute} from '../../../app-route';
import {ActivationPage} from '../../../layout/activation-page/activation-page';
import {useDocumentationLinks} from '../../../provider/help-links/help-links-hook';
import {Locale} from '../../../provider/locale/locale';
import {FeaturesEnum} from '../../../service/user/user-type';

export function PricesActivation(): JSX.Element {
    const {featureActivation} = useDocumentationLinks();

    return (
        <ActivationPage
            breadCrumbList={[
                {
                    path: appRoute.products.path,
                    titleLangKey: 'CATEGORY_NAME__PRODUCTS',
                },
            ]}
            interestedMessageLangKey="ACTIVATION_PAGE__INTERESTED_CONTACT_YOUR_MANAGER_TO_ACTIVATE_THIS_SERVICE"
            link={featureActivation[FeaturesEnum.prices]}
            title={<Locale stringKey="CATEGORY_NAME__PRODUCTS" />}
        />
    );
}
